import React, { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/login.css";
import ephLogo from "../images/eph_logo.png";
import LoadingIcon from "../images/Loading_icon.gif";
import Swal from "sweetalert2";
import linkedin from "../images/linkedin-3-16.png";
import ReCAPTCHA from "react-google-recaptcha";
import { UrlContext } from "../contexts/UrlContext";
import reactGa from "react-ga4";

export default function ConsultantLogin() {
  useEffect(() => {
    document.title = "EPH Consultant";
  }, []);
  const recaptchaRef = React.createRef();
  const navigate = useNavigate();
  const token =
    localStorage.getItem("AccessToken") ||
    localStorage.getItem("linkedinToken");

  const [firstTime, setFirstTime] = useState(false);
  const [loading, setLoading] = useState(false);
  const [captchaToken, setCaptchaToken] = useState("");
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [error, setError] = useState("");

  const invisibleCaptchaKey = "6Lfvkq8pAAAAAJEgk6BDUbP8Aj67IsHdvQaer5yk";
  const [serverCaptcha, setServerCaptcha] = useState("");
  const [resetPassword, setResetPassword] = useState(false);
  const [recoveryEmail, setRecoveryEmail] = useState("");
  const [validateRecoveryEmail, setValidateRecoveryEmail] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  const { API_URL, URI } = useContext(UrlContext);
  useEffect(() => {
    if (token) {
      window.location.href = `/app`;
    }
  }, []);

  useEffect(() => {
    if (captchaToken) {
      fetch(`${API_URL}check-captcha-validity`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ captchaToken, serverCaptcha }),
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.success) {
            setCaptchaVerified(true);
          } else {
            setCaptchaVerified(false);
          }
        })
        .catch((err) => console.log(err));
    }
    if (!captchaToken) {
      setCaptchaVerified(false);
    }
  }, [captchaToken]);

  useEffect(() => {
    if (
      recoveryEmail.length > 0 &&
      recoveryEmail.includes("@") &&
      recoveryEmail.includes(".") &&
      !recoveryEmail.includes("email@email.com")
    ) {
      setValidateRecoveryEmail(true);
    } else {
      setValidateRecoveryEmail(false);
    }
  }, [recoveryEmail]);

  const loginWithEmail = (e) => {
    setLoading(true);
    if (captchaVerified) {
      e.preventDefault();
      const email = e.target.parentElement[0].value;
      fetch(`${API_URL}consultant-data-with-email`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: email.trim().toLowerCase(),
          password: e.target.parentElement[1].value,
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          reactGa.event({
            category: "Consultant",
            action: "Login with email",
            parameters: {
              consultant_email: `${email}`,
            },
          });
          setLoading(false);
          if (data.status == "success") {
            localStorage.setItem("AccessToken", data.token);
            window.location.href = `/app`;
            setError("");
            if (data.ntbc) {
              localStorage.setItem("ntbc", true);
            }
          }
          if (data.status == "error") {
            setError(data.message);
          }
        })
        .catch((err) => {
          console.log(err);
          setLoading(false);
        });
    } else {
      setError("Complete Captcha challenge");
      setLoading(false);
    }
  };
  const recoverPassword = () => {
    if (validateRecoveryEmail) {
      setLoading(true);
      fetch(`${API_URL}recover-password`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: recoveryEmail.trim().toLowerCase(),
        }),
      })
        .then((res) => res.json())
        .then((data) => {
          reactGa.event({
            category: "Consultant",
            action: "Recover Password",
            parameters: {
              consultant_email: `${recoveryEmail}`,
            },
          });
          setLoading(false);
          if (data.status == "success") {
            Swal.fire({
              title: "Password Generated",
              text: `Please check your inbox. If you did not receive a message, please also check your SPAM folder or contact our Support team (support@expertpowerhouse.com)​`,
              icon: "success",
              showConfirmButton: true,
              showCloseButton: true,
              confirmButtonColor: "#37515e",
              color: "darkgray",
            });
            setResetPassword(false);
          }
          if (data.status == "error") {
            Swal.fire({
              title: "Something went wrong",
              text: `${data.message}\n get in touch with your EPH contact or click on "Create Account" on the next page`,
              icon: "error",
              showConfirmButton: false,
              showCloseButton: true,
              confirmButtonColor: "#37515e",
              color: "darkgray",
            });
            setResetPassword(false);
          }
        })
        .catch((err) => {
          setLoading(false);
          console.log(err);
        });
    }
  };

  return (
    <>
      <div className="eph-login-body">
        <div className="eph-login-wrapper fadeInDown">
          <div className="eph-login-formContent" style={{ color: "darkgray" }}>
            <div className="fadeIn first">
              <img className="eph-login-logo" src={ephLogo} alt="EPH Logo" />
            </div>
            {!firstTime ? (
              <div
                className="mx-4"
                style={{
                  display: "inline-flex",
                  flexDirection: "column",
                  alignItems: "center",
                  width: "80%",
                }}
              >
                <form
                  style={{ width: "100%" }}
                  className="my-2"
                  onSubmit={(e) => e.preventDefault()}
                  onFocus={() => recaptchaRef.current.execute()}
                >
                  <div className="form-group">
                    <input
                      style={{ width: "100%", margin: "0" }}
                      placeholder="Email"
                      type="email"
                      className="form-control"
                      id="inputEmailConsultant"
                      onChange={(e) => setRecoveryEmail(e.target.value)}
                    />
                  </div>
                  <div className="form-group">
                    <input
                      placeholder="Password"
                      type="password"
                      className="form-control"
                      id="inputPasswordConsultant"
                    />
                    <span
                      style={{ cursor: "pointer" }}
                      onClick={() => setResetPassword("Reset your password")}
                    >
                      Forgot your password?
                    </span>
                  </div>
                  {!loading ? (
                    <button
                      style={{
                        backgroundColor: "#37515e",
                        color: "white",
                        width: "100%",
                      }}
                      type="submit"
                      className="btn mt-1"
                      onClick={(e) => loginWithEmail(e)}
                    >
                      Log In
                    </button>
                  ) : (
                    <img
                      className="login-loading-icon"
                      src={LoadingIcon}
                      alt="Loading..."
                      style={{ translate: "-20px 20px" }}
                    />
                  )}
                  {error ? (
                    <div
                      className="alert alert-danger mt-2 fadeIn"
                      style={{ width: "100%" }}
                      role="alert"
                    >
                      {error}
                    </div>
                  ) : null}

                  <ReCAPTCHA
                    ref={recaptchaRef}
                    size="invisible"
                    sitekey={invisibleCaptchaKey}
                    onChange={(value) => {
                      setCaptchaToken(value);
                      setServerCaptcha(
                        "6Lfvkq8pAAAAANBQQAwSyWkRHGYh4D0obJyQrvjo"
                      );
                    }}
                  />
                </form>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    width: "100%",
                    alignItems: "center",
                    justifyContent: "center",
                    margin: "5px 0", boxSizing: "border-box",
                  }}
                >
                  <span
                    style={{
                      width: "50%",
                      borderBottom: "1px solid darkgray",
                    }}
                  ></span>
                  <span>or</span>
                  <span
                    style={{
                      width: "50%",
                      borderBottom: "1px solid darkgray",
                    }}
                  ></span>
                </div>
                <div
                  style={{
                    width: "100%",
                    border: "1px solid lightgrey",
                    height: "40px",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "10px 0", boxSizing: "border-box",
                  }}
                >
                  <a
                    style={{ width: "100%" }}
                    href={
                      token && token !== "undefined"
                        ? `${URI}app/`
                        : `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=77wlrb8jlxzifu&redirect_uri=${URI}app&scope=profile%20email%20openid`
                    }
                    onClick={reactGa.event({
                      category: "Consultant",
                      action: "Login with Linkedin",
                    })}
                  >
                    <img
                      src={linkedin}
                      alt="Log in for consultant"
                      style={{
                        height: "30px",
                        cursor: "pointer",
                        marginRight: "10px",
                      }}
                    />
                    <span style={{ textDecoration: "none", color: "darkgray" }}>
                      {" "}
                      Sign in with Linkedin
                    </span>
                  </a>
                </div>
              </div>
            ) : null}

            <div className="eph-login-formFooter">
              <span
                onClick={() => setResetPassword("First time login")}
                style={{ cursor: "pointer" }}
              >
                First time login?
              </span>

              <div
                className="m-2"
                style={{ borderBottom: "2px solid lightgray" }}
              ></div>

              <span
                onClick={() =>
                  window.open(
                    "https://tool.expertpowerhouse.com/new-application"
                  )
                }
                style={{ cursor: "pointer" }}
              >
                Create an account
              </span>

              {/* <input
                placeholder="Linkedin account email"
                type="email"
                onChange={(e) => {
                  setLinkedinEmail(e.target.value);
                }}
              ></input> */}
            </div>
          </div>
        </div>
      </div>
      {resetPassword ? (
        <div
          className="modal"
          tabindex="-1"
          style={{ display: "block", width: "100vw" }}
          role="dialog"
        >
          <div
            className="modal-dialog"
            role="document"
            style={{ color: "darkgray" }}
          >
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{resetPassword}</h5>
                <i
                  style={{ fontSize: "20px" }}
                  className="fa-solid fa-xmark mr-2 mt-2 "
                  type="button"
                  onClick={() => setResetPassword(false)}
                  aria-label="Close"
                />
              </div>
              <div className="modal-body">
                <input
                  type="email"
                  placeholder="Email"
                  value={recoveryEmail}
                  className="form-control mb-3"
                  id="exampleInputEmail1"
                  aria-describedby="emailHelp"
                  onChange={(e) => setRecoveryEmail(e.target.value)}
                />
                <input
                  type="checkbox"
                  checked={isChecked}
                  onChange={(e) => setIsChecked(!isChecked)}
                />
                <span className="ml-2">
                  I agree with EPH{" "}
                  <a
                    style={{ textDecoration: "none", color: "#37515e" }}
                    target="_blank"
                    href="https://www.expertpowerhouse.com/privacy-policy"
                  >
                    Privacy Policy
                  </a>{" "}
                  {" & "}{" "}
                  <a
                    style={{ textDecoration: "none", color: "#37515e" }}
                    target="_blank"
                    href="https://www.expertpowerhouse.com/terms-of-use"
                  >
                    Terms of use
                  </a>
                </span>
              </div>
              {isChecked ? null : (
                <span style={{ color: "red", textAlign: "center" }}>
                  You need to agree with privacy policy and terms of use
                </span>
              )}
              <div className="modal-footer">
                <button
                  style={{ backgroundColor: "#37515e", color: "white" }}
                  type="button"
                  className="btn btn-primary"
                  disabled={!validateRecoveryEmail || loading || !isChecked}
                  onClick={() => {
                    if (isChecked) {
                      recoverPassword();
                    }
                  }}
                >
                  {resetPassword == "First time login"
                    ? "Generate Password"
                    : "Reset Password"}
                </button>
              </div>
            </div>
          </div>
        </div>
      ) : null}
    </>
  );
}
